module.exports = __webpack_public_path__ + "img/nothing.eb3eeb1f.png";